(() => {
  const selector = '[data-product-benefits-lottie]';
  const playerUrl = 'https://unpkg.com/@lottiefiles/dotlottie-wc@0.9.24/dist/dotlottie-wc.js';

  function loadPlayer() {
    if (customElements.get('dotlottie-wc')) return Promise.resolve();
    if (window.dwDotLottiePlayerPromise) return window.dwDotLottiePlayerPromise;
    window.dwDotLottiePlayerPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = playerUrl;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return window.dwDotLottiePlayerPromise;
  }

  function activate(section) {
    const players = section.querySelectorAll('dotlottie-wc[data-src]');
    if (!players.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    players.forEach((player) => {
      player.setAttribute('src', player.dataset.src);
      player.removeAttribute('data-src');
      if (reduceMotion) {
        player.removeAttribute('autoplay');
        player.removeAttribute('loop');
      }
    });
    loadPlayer().catch(() => {
      section.classList.add('dw-product-benefits--player-error');
    });
  }

  function init(scope = document) {
    scope.querySelectorAll(selector).forEach((section) => {
      if (section.dataset.lottieReady === 'true') return;
      section.dataset.lottieReady = 'true';
      if (!('IntersectionObserver' in window)) {
        activate(section);
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        activate(section);
      }, { rootMargin: '300px 0px' });
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();